import { render, staticRenderFns } from "./NavigationContainer.vue?vue&type=template&id=53b7efed&"
import script from "./NavigationContainer.vue?vue&type=script&lang=js&"
export * from "./NavigationContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports